// @ts-ignore
import {apiClient, MultiSpaceBooking, Order, Space, SpaceBooking, Void, Workflow} from "rp-components"

export interface SpacesService {
    getBooking(propertyId: number, spaceId: string, bookingId: string): Promise<SpaceBooking>
    getSpaces(propertyId: number): Promise<Space[]>
    getSpace(propertyId: number, spaceId: String): Promise<Space>
    getSpaceBookings(propertyId: number, spaceId: String, since: number, until: number): Promise<Space>
    getPropertySpaceBookings(propertyId: number, since: number, until: number): Promise<SpaceBooking[]>
    getUserSpaceBookings(since: number): Promise<SpaceBooking[]>
    updateSpaceBooking(spaceBooking: SpaceBooking, updateAssociatedBookings?: boolean): Promise<SpaceBooking>
    cancelSpaceBooking(propertyId: number, spaceId: string, bookingId: string, includeAssociatedBookings?: boolean): Promise<SpaceBooking>
    createBookingOrder(booking: MultiSpaceBooking): Promise<Void>
    checkSpaceAvailability(booking: SpaceBooking): Promise<Void>
    getSpaceBookingWorkflow(propertyId: number, spaceId: string, bookingId: string): Promise<Workflow>
}

export class SpacesServiceImpl implements SpacesService {
    static instance?: SpacesService = undefined

    private constructor() {}

    static getInstance(): SpacesService {
        if (SpacesServiceImpl.instance == undefined) {
            SpacesServiceImpl.instance = new SpacesServiceImpl()
        }
        return SpacesServiceImpl.instance
    }

    async getBooking(propertyId: number, spaceId: string, bookingId: string): Promise<SpaceBooking> {
        return apiClient.get<SpaceBooking>(`/properties/${propertyId}/spaces/${spaceId}/bookings/${bookingId}`)
    }

    async getSpaces(propertyId: number): Promise<Space[]> {
        return apiClient.get(`/properties/${propertyId}/spaces`)
    }

    async getSpace(propertyId: number, spaceId: String): Promise<Space> {
        return await apiClient.get(`/properties/${propertyId}/spaces/${spaceId}`)
    }

    async getSpaceBookings(propertyId: number, spaceId: String, since: number, until: number): Promise<Space> {
        const params = { since: since, until: until }
        return await apiClient.get(`/properties/${propertyId}/spaces/${spaceId}/bookings`, params)
    }

    async updateSpaceBooking(spaceBooking: SpaceBooking, updateAssociatedBookings?: boolean | undefined): Promise<SpaceBooking> {
        let uri = `/properties/${spaceBooking.propertyId}/spaces/${spaceBooking.spaceId}/bookings`
        if (updateAssociatedBookings !== undefined) {
            uri += `?includeAssociatedBookings=${updateAssociatedBookings}`
        }
        return await apiClient.patch(uri, spaceBooking)
    }

    async cancelSpaceBooking(propertyId: number, spaceId: string, bookingId: string, includeAssociatedBookings?: boolean): Promise<SpaceBooking> {
        const params = {
            includeAssociatedBookings: includeAssociatedBookings
        }
        return await apiClient.delete(`/properties/${propertyId}/spaces/${spaceId}/bookings/${bookingId}`, params)
    }

    async getPropertySpaceBookings(propertyId: number, since: number, until: number): Promise<SpaceBooking[]> {
        const params = {
            since: since,
            until: until,
            includeShared: true
        }
        return await apiClient.get(`/properties/${propertyId}/spaces/bookings`, params)
    }

    async getUserSpaceBookings(since: number): Promise<SpaceBooking[]> {
        return await apiClient.get(`/user/spaceBookings?since=${since}`)
    }

    async createBookingOrder(booking: MultiSpaceBooking): Promise<Order> {
        return await apiClient.post<Order, Void>(`/properties/${booking.propertyId}/spaces/bookings`, booking)
    }

    async checkSpaceAvailability(booking: SpaceBooking): Promise<Void> {
        return await apiClient.post<Void, SpaceBooking>(`/properties/${booking.propertyId}/spaces/availability`, booking)
    }

    async getSpaceBookingWorkflow(propertyId: number, spaceId: string, bookingId: string): Promise<Workflow> {
        return await apiClient.get<Workflow>(`/properties/${propertyId}/spaces/${spaceId}/bookings/${bookingId}/workflow`)
    }
}

export default SpacesServiceImpl.getInstance()
